import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { deleteGroup, updateGroup, addGroup } from '@/redux/actions';
import { useNavigate } from 'react-router-dom';

const WS_GROUPS_BY_HTTP = {
	CREATE_GROUP: 'groups/POST',
	UPDATE_GROUP: 'groups/:groupID/PATCH',
	DELETE_GROUP: 'groups/:groupID/DELETE',
	DUPLICATE_GROUP: 'groups/:groupID/duplicate/PATCH',
};

const EventGroupsSubcriptions = props => {
	const { socket, currentEventId, addGroup, deleteGroup, updateGroup, children } = props;
	const navigate = useNavigate();
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToEventGroups = () => {
		socket.emit('event/groups/:eventID/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ EventGroupsSubscriptions Mounted ⚡️');
	};

	const unsubscribeToEventGroups = () => {
		socket.emit('event/groups/:eventID/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ EventGroupsSubscriptions Unmounted 🚶‍♂️`);
	};

	const listenForCreatedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.CREATE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while creating group', error);
			else {
				const { name, id } = data;
				const { socketID } = payload;
				if (socketID === socket.id) navigate(`/events/${currentEventId}/groups/${id}`);
				else addGroup(data);

				displayMessage(`${name} group created`);
			}
		});
	};

	const listenForDuplicatedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.DUPLICATE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while duplicating group', error);
			else {
				const { name } = data;
				addGroup(data);
				displayMessage(`${name} group duplicated`);
			}
		});
	};

	const listenForUpdatedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.UPDATE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while updating group', error);
			else {
				const { name } = data;
				updateGroup(data);
				displayMessage(`${name} group updated`);
			}
		});
	};

	const listenForDeletedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.DELETE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while deleting group', error);
			else {
				const { deleteGroup: group, groupName } = data;
				deleteGroup(group.id);
				displayMessage(`${groupName} group deleted`);
			}
		});
	};

	const listeners = () => [
		listenForCreatedGroup,
		listenForUpdatedGroup,
		listenForDeletedGroup,
		listenForDuplicatedGroup,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToEventGroups}
				unsub={unsubscribeToEventGroups}
				listeners={listeners()}
				routes={Object.values(WS_GROUPS_BY_HTTP)}
				from="event-groups"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	addGroup: group => dispatch(addGroup(group)),
	updateGroup: group => dispatch(updateGroup(group)),
	deleteGroup: groupID => dispatch(deleteGroup(groupID)),
});

export default connect(msp, mdp)(EventGroupsSubcriptions);
